import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { DialogTitle } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    content: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '552px'
        }
    }
}));

function PreviewSimple(props) {
    const classes = useStyles();

    return (
        <Dialog
            open={true}
            onClose={props.onClose}
            style={{ zIndex: 40 }}
        >
        <DialogTitle className="p-5 flex" disableTypography>
            <span className="flex-1 py-5 px-10">{props.title || ''}</span>
            <IconButton size="small" color="inherit" onClick={props.onClose} aria-label="close">
                <CloseIcon />
            </IconButton>
        </DialogTitle>
            <DialogContent>
                <div className={classes.content}>
                    {props.imageUrl && <div className="w-full flex justify-center"><img src={props.imageUrl} /></div>}
                    {props.svg && <div className="w-full flex justify-center" dangerouslySetInnerHTML={{ __html: props.svg }} />}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default PreviewSimple;